import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { SnagsPage } from '@/features/quality/snags-page';

const searchSchema = z.object({
  snag: z.string().optional().catch(undefined),
  plan: z.string().optional().catch(undefined),
  view: z.enum(['list', 'plan']).optional().catch(undefined),
});

export const Route = createFileRoute('/_app/projects/$projectId/quality/snags')({
  validateSearch: searchSchema,
  component: PageRoute,
});

function PageRoute() {
  const { projectId } = Route.useParams();
  const search = Route.useSearch();
  return (
    <SnagsPage projectId={projectId} snagId={search.snag} planId={search.plan} view={search.view} />
  );
}
